import { render, staticRenderFns } from "./InPurchaseRequest.vue?vue&type=template&id=0a18173c&scoped=true&"
import script from "./InPurchaseRequest.vue?vue&type=script&lang=js&"
export * from "./InPurchaseRequest.vue?vue&type=script&lang=js&"
import style0 from "./InPurchaseRequest.vue?vue&type=style&index=0&id=0a18173c&prod&lang=scss&scoped=true&"
import style1 from "./InPurchaseRequest.vue?vue&type=style&index=1&id=0a18173c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a18173c",
  null
  
)

export default component.exports